import { render, staticRenderFns } from "./Trilha.vue?vue&type=template&id=deac72d4&scoped=true"
import script from "./Trilha.vue?vue&type=script&lang=js"
export * from "./Trilha.vue?vue&type=script&lang=js"
import style0 from "./Trilha.vue?vue&type=style&index=0&id=deac72d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deac72d4",
  null
  
)

export default component.exports